import { RestApi } from 'app/auth/rest.api';
import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import { IConnector, IConnectorType, ISapTestResponse } from './IConnector';

@Injectable()
export class ConnectConnectorsService {

  private _endPoints = {
    getConnectors: 'api/ExternalSystem/Connectors',
    getConnector: 'api/ExternalSystem/Connectors/{type}/{id}',
    getConnectorMetadata: 'api/ExternalSystem/Connector/Metadata',
    saveConnector: 'api/ExternalSystem/Connector',
    testConnector:"api/ExternalSystem/Connector/Test"
  };

  constructor(private _restApi: RestApi) { }

  public getConnectors(): Promise<IConnectorType[]> {
    return this._restApi.get(this._endPoints.getConnectors).toPromise() as Promise<IConnectorType[]>;
  }

  public getConnector(connectorType: string, connectorId: string): Promise<IConnector> {
    return this._restApi.get(this._endPoints.getConnector.replace( '{type}', connectorType).replace( '{id}', connectorId))
      .toPromise() as Promise<IConnector>;
  }

  public getConnectorMetadata(): any {
    return this._restApi.get(this._endPoints.getConnectorMetadata).map((res) => res.properties).toPromise() as Promise<any>;
  }

  public saveConnector(connector: any): Promise<IConnector> {
    return this._restApi.put(this._endPoints.saveConnector, connector).toPromise() as Promise<IConnector>;
  }

  public testConnector(connector: any): Promise<ISapTestResponse> {
    return <Promise<ISapTestResponse>>this._restApi.post(this._endPoints.testConnector, connector).toPromise();
  }
}
